import crypto from 'crypto';
import CryptoJS from 'crypto-js';

export const encryptPayload = (data: any) => {
	const encryptKey = `${process.env.NEXT_PUBLIC_WEB_AES_KEY}`;
	const keyBytes = crypto.createHash('sha256').update(encryptKey).digest();

	if (![16, 24, 32].includes(keyBytes.length)) {
		throw new Error('Invalid key length. Key must be 16, 24, or 32 bytes.');
	}
	const iv = crypto.randomBytes(16);
	const cipher = crypto.createCipheriv('aes-256-cfb', keyBytes, iv);
	const encrypted = Buffer.concat([cipher.update(data, 'utf8'), cipher.final()]);
	const cipherText = Buffer.concat([iv, encrypted]).toString('base64');
	return cipherText;
};

export const encryptCodeApi = (data: any) => {
	const key = `${process.env.NEXT_PUBLIC_SECRET_KEY}`;
	const resultEncryptCode = CryptoJS.HmacSHA256(data, key).toString(CryptoJS.enc.Hex);
	return resultEncryptCode;
};

export const encryptDLogin = (data: any) => {
	const key = `${process.env.NEXT_PUBLIC_SECRET_KEY}`;
	const encrypted = CryptoJS.AES.encrypt(data, key).toString();
	return encrypted;
};

export const decryptDLogin = (data: any) => {
	const key = `${process.env.NEXT_PUBLIC_SECRET_KEY}`;
	const bytes = CryptoJS.AES.decrypt(data, key);
	const decrypted = bytes.toString(CryptoJS.enc.Utf8);
	return JSON.parse(decrypted);
};

export const decryptDLoginBE = (data: any) => {
	const key = `${process.env.NEXT_PUBLIC_WEB_AES_KEY}`;
	const keyBuffer = crypto.createHash('sha256').update(key).digest();

	const cipherData = Buffer.from(data, 'base64');

	if (cipherData.length < 16) {
		throw new Error('Cipher text too short');
	}

	const iv = cipherData.slice(0, 16);
	const encryptedData = cipherData.slice(16);

	const decipher = crypto.createDecipheriv('aes-256-cfb', keyBuffer, iv);
	const decrypted = Buffer.concat([decipher.update(encryptedData), decipher.final()]);

	return JSON.parse(decrypted.toString('utf-8'));
};